export default class Cipher {
  constructor({
    id,
    name,
    description,
    crypt,
    input,
    buttons
  }) {
    this.id = id
    this.name = name;
    this.description = description;
    this.crypt = crypt;
    this.input = input;
    this.buttons = buttons;
  }
}
